export const ACCIDENT_REPORT_ACTION_TYPES = {
    SET_ACCIDENT_REPORT_STEP: 'SET_ACCIDENT_REPORT_STEP',
    SET_ACCIDENT_REPORT_STARTUP_FIELDS: 'SET_ACCIDENT_REPORT_STARTUP_FIELDS',
    SET_ACCIDENT_REPORT_PERSON_FIELDS: 'SET_ACCIDENT_REPORT_PERSON_FIELDS',
    SET_ACCIDENT_REPORT_ACCIDENT_FIELDS: 'SET_ACCIDENT_REPORT_ACCIDENT_FIELDS',
    SET_ACCIDENT_REPORT_SPECIAL_FIELDS: 'SET_ACCIDENT_REPORT_SPECIAL_FIELDS',
    SET_ACCIDENT_REPORT_STEPS_VALIDATED: 'SET_ACCIDENT_REPORT_STEPS_VALIDATED'
};